export const loadCanvasWithInputFile = async function(file){
    // canvas
    const canvas = document.createElement('canvas');
    const context = canvas.getContext("2d");
    const img = new Image();
    // if(!file.type.match('image.*'))
    //     alert("not an image");

    const reader = new FileReader();

    const promise = await new Promise((resolve, reject) =>{
        // Read in the image file as a data URL.
        reader.readAsDataURL(file);
        reader.onload = function(evt){
            if( evt.target.readyState == FileReader.DONE) {
                img.src = evt.target.result;
                // context.drawImage(img,100,100);

                img.onload = () => {
                    let scale = getScaleBySize(img, {
                        width: 1920,
                        height: 1080
                    });
                    if (scale > 1)
                        scale = 1;

                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    context.drawImage(
                        img,
                        0,
                        0,
                        img.width,
                        img.height,
                        0,
                        0,
                        canvas.width,
                        canvas.height);
                    resolve(canvas);
                }
                // resolve();

            }
        }
    });

    return promise;

}

export const getScaleBySize = function(sourceSize, targetSize) {
    let dw = targetSize.width / sourceSize.width;
    let dh = targetSize.height / sourceSize.height;
    let scale = (dw < dh) ? dw : dh;
    return scale
}

export const dataURLToBlob = function (dataURL) {
    let byteString = atob(dataURL.split(',')[1]);
    let mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0]
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], {type: mimeString});
}

export const blobToFile = function (theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
};
